import axiosInstance from '../helpers/axiosInstance'

export const updateAccountProfile = async (payload) => {
    try {
        const response = await axiosInstance.put("/account/profile", payload);
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchAccountProfile = async () => {
    try {
        const response = await axiosInstance.get("/account/profile");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const changeAccountPassword = async (newPassword, confirmPassword) => {
    try {
        const response = await axiosInstance.post("/account/password/change", {
            new_password: newPassword,
            confirm_password: confirmPassword,
        });
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const checkPasswordChangeEligibility = async () => {
    try {
        const response = await axiosInstance.get("/account/password/eligibility");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deactivateAccount = async () => {
    try {
        const response = await axiosInstance.post("/account/deactivate");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const checkAccountDeactivationStatus = async () => {
    try {
        const response = await axiosInstance.get("/account/status");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const restoreAccount = async () => {
    try {
        const response = await axiosInstance.post("/account/restore");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchNotificationPreferences = async () => {
    try {
        const response = await axiosInstance.get("/account/notifications/preferences");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateNotificationPreferences = async (preferences) => {
    try {
        const response = await axiosInstance.put("/account/notifications/preferences", preferences);
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchAllUserNotificationPreferences = async () => {
    try {
        const response = await axiosInstance.get("/account/admin/notifications/all");
        if (response.status !== 200) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};